import { useLayoutEffect, useRef } from "react";

/** Прямоугольник, которым дропдаун РЕАЛЬНО обрезан: вьюпорт вместе с предками,
 *  у которых overflow не visible.
 *
 *  09.09: подсказка внутри bottom-sheet резалась телом листа. У .asBody задан
 *  overflow-y: auto, из-за чего вычисленный overflow-x тоже становится auto и лист
 *  обрезает absolute-потомка по обеим осям, а его нижняя кромка лежит выше низа
 *  экрана на высоту подвала. Кламп по одному вьюпорту этого не видел и не двигал
 *  ничего, хотя подсказка уже была срезана. */
function clipBox(el: HTMLElement) {
  let l = 8, t = 8, r = window.innerWidth - 8, b = window.innerHeight - 8;
  for (let p = el.parentElement; p; p = p.parentElement) {
    const s = getComputedStyle(p);
    if (s.overflowX !== "visible" || s.overflowY !== "visible") {
      const q = p.getBoundingClientRect();
      l = Math.max(l, q.left + 4); t = Math.max(t, q.top + 4);
      r = Math.min(r, q.right - 4); b = Math.min(b, q.bottom - 4);
    }
    if (s.position === "fixed") break;
  }
  return { l, t, r, b };
}

/** Кламп absolute-дропдауна (26.08, владелец: «дропдауны чипов опять вылазят за
 *  экран»). После открытия: сдвиг внутрь по горизонтали, при нехватке места снизу —
 *  флип вверх, при нехватке и сверху — maxHeight со скроллом. `key` — значение
 *  открытого пункта: меняется → пересчёт. */
export function useClampPop<T extends HTMLElement>(key: unknown) {
  const ref = useRef<T | null>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (key == null || key === false || !el) return;
    el.style.transform = ""; el.style.top = ""; el.style.bottom = ""; el.style.maxHeight = ""; el.style.overflowY = "";
    const c = clipBox(el);
    const r = el.getBoundingClientRect();
    const overR = r.right - c.r;
    const overL = c.l - r.left;
    if (overR > 0) el.style.transform = `translateX(${-overR}px)`;
    else if (overL > 0) el.style.transform = `translateX(${overL}px)`;
    if (r.bottom > c.b) {
      el.style.top = "auto"; el.style.bottom = "calc(100% + 4px)";
      const r2 = el.getBoundingClientRect();
      if (r2.top < c.t) { el.style.maxHeight = `${r2.bottom - c.t}px`; el.style.overflowY = "auto"; }
    }
  }, [key]);
  return ref;
}
